export default [
  {
    // icon: 'mdi-account-multiple',
    icon: 'mdi-face-agent',
    component: () => import(/* webpackChunkName: "my-consultant" */ './views/MyConsultant'),
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/myconsultant';
    },
    name: 'Mi Asesor',
    path: '/myconsultant',
    id: 'myconsultant-toolbar',
    meta: {
      requiresAuth: true,
      allowedRoles: [
        'lopd',
        'pyme',
        'autonomous',
        'employees',
        'consultant',
        'admin',
        'superadmin',
      ],
      toolbar: true,
      badge: true,
      badgeContent: 'unreadedUserMessages',
      badgeChecker: 'userMessagesReady',
      tooltip: null,
    },
    children: [
      {
        name: 'threadDetail',
        path: '/myconsultant/thread/:thread',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/myconsultant';
        },
        component: () =>
          import(/* webpackChunkName: "myconsultant-detail" */ './views/MyConsultant'),
        meta: {
          allowedRoles: [
            'lopd',
            'pyme',
            'autonomous',
            'employees',
            'consultant',
            'admin',
            'superadmin',
          ],
          requiresAuth: true,
          drawer: false,
          tooltip: null,
        },
      },
    ],
  },
];
